<script lang="ts">
	import type { Device } from 'src/types/Device';
	import LightAdvancedView from 'src/components/Sidepanel/DeviceViews/Light/LightAdvancedView.svelte';

	export let device: Device;
</script>

<!-- For now we only use the advanced view for light devices. However the logic for view change remains, if we need to use it, for future changes. -->
<LightAdvancedView {device} />
